/* beadboo — логика 4-шагового конфигуратора (snippets/beadboo-customizer.liquid)
   Состояние → hidden inputs (line item properties) → уходит в корзину с формой Dawn.
   Валидация: перехват submit продукт-формы; неполные шаги подсвечиваем и скроллим. */

if (!customElements.get('beadboo-customizer')) {
  customElements.define(
    'beadboo-customizer',
    class BeadbooCustomizer extends HTMLElement {
      constructor() {
        super();
        this.props = {};
        this.querySelectorAll('[data-bbc-prop]').forEach((el) => {
          this.props[el.dataset.bbcProp] = el;
        });
        this.charms = [null, null]; // слоты 1/2
        this.charmOrder = []; // индексы слотов в порядке заполнения (для FIFO-замены при полных слотах)
        this.backType = 'Phone';

        this.initCharms();
        this.initFont();
        this.initText();
        this.initStyle();
        this.initValidation();
        this.initWizard();
        /* замер мог пройти на fallback-шрифте. fonts.ready недостаточно: он
           резолвится ДО начала лениво-триггеримых загрузок (проверено в харнессе
           2026-07-21 — длинные имена оставались непожатыми). loadingdone стреляет
           после каждой фактической догрузки шрифта — тогда и перемеряем. */
        if (document.fonts) {
          const resync = () => {
            this.renderTag();
            this.syncMiniShift();
          };
          document.fonts.ready.then(resync);
          document.fonts.addEventListener('loadingdone', resync);
        }
        // первичный оптический центр мини-тега (на fallback; уточнится после загрузки шрифта)
        requestAnimationFrame(() => this.syncMiniShift());
      }

      /* ── STEP 1 · style → цвет фото-тега в превью шага 4 ──
         Радио Style живут в variant picker Dawn (name="Style-N") и
         перерисовываются при смене варианта → слушаем change на document. */
      initStyle() {
        this.stage = this.querySelector('[data-bbc-stage]');
        if (!this.stage) return;
        try {
          this.styleMap = JSON.parse(this.stage.dataset.bbcStylemap || '{}');
        } catch (e) {
          this.styleMap = {};
        }
        // цвет букв гравировки фиксирован за стилем (не выбирается клиентом)
        try {
          this.inkMap = JSON.parse(this.stage.dataset.bbcInkmap || '{}');
        } catch (e) {
          this.inkMap = {};
        }
        // тень гравировки = затемнённый цвет тега (эффект «утопленности»)
        try {
          this.shadowMap = JSON.parse(this.stage.dataset.bbcShadowmap || '{}');
        } catch (e) {
          this.shadowMap = {};
        }
        // задняя сторона тега: у стиля может быть своя картинка для Back
        // (Polka Pup: точки только спереди, зад чистый); нет ключа → как спереди
        try {
          this.backMap = JSON.parse(this.stage.dataset.bbcBackmap || '{}');
        } catch (e) {
          this.backMap = {};
        }
        this.tagImg = this.stage.querySelector('[data-bbc-tagimg]');
        this.tagSvg = this.stage.querySelector('[data-bbc-tagsvg]');
        // мини-тег в схеме ошейника (шаг 2) — тот же цвет, что большое превью
        this.miniImg = this.querySelector('[data-bbc-minimg]');
        this.miniSvg = this.querySelector('[data-bbc-minisvg]');

        const isStyleInput = (el) =>
          el &&
          ((el.matches('input[type="radio"]') && /^Style(-\d+)?$/.test(el.name)) ||
            (el.matches('select') && /options\[Style\]/.test(el.name || '')));

        document.addEventListener('change', (e) => {
          if (isStyleInput(e.target)) this.applyStyle(e.target.value);
        });

        // канонический путь Dawn: pub/sub variantChange (переживает любые
        // перерисовки пикера; variant.options = имена выбранных значений)
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const opts = (event && event.data && event.data.variant && event.data.variant.options) || [];
            const hit = opts.find((v) => this.styleMap[v]);
            this.applyStyle(hit || opts[0] || '');
          });
        }

        // начальное состояние (первый вариант Style выбран по умолчанию)
        const checked = document.querySelector('input[type="radio"][name^="Style-"]:checked');
        const dropdown = document.querySelector('select[name="options[Style]"]');
        this.applyStyle(checked ? checked.value : dropdown ? dropdown.value : '');
      }

      /* картинка большого превью зависит от стиля И стороны (front/back):
         у Polka Pup зад без точек — на Back подставляем картинку из backMap */
      syncTagFace() {
        if (!this.stage || !this.tagImg || !this.currentStyle) return;
        const front = this.styleMap[this.currentStyle];
        if (!front) return;
        const url = this.side === 'back' ? (this.backMap && this.backMap[this.currentStyle]) || front : front;
        if (this.tagImg.getAttribute('src') !== url) this.tagImg.src = url;
        this.stage.style.setProperty('--bbc-tagsrc', 'url("' + url + '")');
      }

      applyStyle(styleName) {
        if (!this.stage) return;
        this.currentStyle = styleName;
        const url = this.styleMap[styleName];
        if (url && this.tagImg) {
          if (this.tagImg.getAttribute('src') !== url) this.tagImg.src = url;
          this.tagImg.classList.remove('is-off');
          if (this.tagSvg) this.tagSvg.classList.add('is-off');
          this.stage.classList.add('has-photo');
          // маска для акрилового глянца = силуэт того же PNG (CSS ::before/::after)
          this.stage.style.setProperty('--bbc-tagsrc', 'url("' + url + '")');
          // если сейчас открыта задняя сторона — учесть back-картинку стиля
          this.syncTagFace();
        } else {
          if (this.tagImg) this.tagImg.classList.add('is-off');
          if (this.tagSvg) this.tagSvg.classList.remove('is-off');
          this.stage.classList.remove('has-photo');
          this.stage.style.removeProperty('--bbc-tagsrc');
        }
        // цвет букв за стилем; нет в карте → '' = CSS-дефолт (белый)
        const ink = (this.inkMap && this.inkMap[styleName]) || '';
        // тень = затемнённый цвет тега; нет в карте → '' = CSS-дефолт (navy)
        const shadow = (this.shadowMap && this.shadowMap[styleName]) || '';
        const miniName = this.querySelector('[data-bbc-mininame]');
        if (this.tagText) {
          this.tagText.style.color = ink;
          this.tagText.style.setProperty('--bbc-shadow', shadow);
        }
        if (miniName) {
          miniName.style.color = ink;
          miniName.style.setProperty('--bbc-shadow', shadow);
        }
        // мини-тег шага 2 повторяет большое превью
        if (url && this.miniImg) {
          if (this.miniImg.getAttribute('src') !== url) this.miniImg.src = url;
          this.miniImg.classList.remove('is-off');
          if (this.miniSvg) this.miniSvg.classList.add('is-off');
        } else {
          if (this.miniImg) this.miniImg.classList.add('is-off');
          if (this.miniSvg) this.miniSvg.classList.remove('is-off');
        }
        // наружу: quick-add чармов подбирает рекомендации под выбранный стиль
        document.dispatchEvent(new CustomEvent('beadboo:style', { detail: { style: styleName } }));
      }

      /* ── STEP 2 · charms (2 слота Left/Right вокруг мини-тега; "None" валиден) ──
         Слоты НЕ сдвигаются: левый и правый — реальные стороны ошейника
         (вид спереди, как смотришь на собаку), убрал левый — правый остался. */
      initCharms() {
        this.slotEls = [this.querySelector('[data-bbc-slot="1"]'), this.querySelector('[data-bbc-slot="2"]')];

        this.querySelectorAll('[data-bbc-charm]').forEach((chip) => {
          chip.addEventListener('click', () => {
            /* «Let us pick» (2026-08-25): делегирование — заполняет ОБА слота
               разом (полу-выбор «мы подберём один чарм» не имеет смысла).
               Повторный клик, когда оба слота уже его, — отменяет. */
            if (chip.hasAttribute('data-bbc-fillboth')) {
              const n = chip.dataset.bbcCharm;
              const both = this.charms[0] && this.charms[1] && this.charms[0].name === n && this.charms[1].name === n;
              if (both) {
                this.charms = [null, null];
                this.charmOrder = [];
              } else {
                const ico = chip.querySelector('.bbc-charm__magicico');
                const html = ico ? ico.outerHTML : '<span class="bbc-charm__magicico">✨</span>';
                this.charms = [
                  { name: n, html: html },
                  { name: n, html: html },
                ];
                this.charmOrder = [0, 1];
              }
              return this.renderCharms();
            }
            /* Оба слота заняты → клик ЗАМЕНЯЕТ самый давний выбор (FIFO), а не
               игнорируется: shake слотов не виден из нижней части грида на мобиле
               (Clarity 2026-08: dead/rage clicks на чармах). Бейджи чипов дают
               фидбек прямо у точки клика, shake оставлен как доп. сигнал. */
            let free = this.charms.indexOf(null);
            if (free === -1) {
              free = this.charmOrder.length ? this.charmOrder.shift() : 0;
              this.flashSlots();
            }
            this.charmOrder.push(free);
            this.charms[free] = {
              name: chip.dataset.bbcCharm,
              html: chip.querySelector('img, .bbc-charm__none, .bbc-charm__emoji').outerHTML,
            };
            this.renderCharms();
          });
        });

        this.slotEls.forEach((slot, i) => {
          slot.addEventListener('click', () => {
            if (!this.charms[i]) return;
            this.charms[i] = null;
            this.charmOrder = this.charmOrder.filter((x) => x !== i);
            this.renderCharms();
          });
        });
      }

      renderCharms() {
        const sides = ['Left', 'Right'];
        this.slotEls.forEach((slot, i) => {
          const c = this.charms[i];
          slot.classList.toggle('is-filled', !!c);
          slot.classList.toggle('is-none', !!c && c.name === 'None');
          slot.innerHTML = c
            ? c.html + '<span class="bbc-slot__x" aria-hidden="true">×</span>'
            : '<span class="bbc-slot__ph">+</span>';
          slot.setAttribute('aria-label', c ? sides[i] + ' charm — ' + c.name + ', click to remove' : sides[i] + ' charm — empty');
        });

        const counts = {};
        this.charms.filter(Boolean).forEach((c) => (counts[c.name] = (counts[c.name] || 0) + 1));
        this.querySelectorAll('[data-bbc-charm]').forEach((chip) => {
          const n = counts[chip.dataset.bbcCharm] || 0;
          chip.classList.toggle('is-picked', n > 0);
          let badge = chip.querySelector('.bbc-charm__badge');
          if (n > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'bbc-charm__badge';
              chip.appendChild(badge);
            }
            // «Let us pick» стоит в обоих слотах, но «×2» на нём читался бы
            // как «два одинаковых» — там всегда просто галочка
            badge.textContent = n > 1 && !chip.hasAttribute('data-bbc-fillboth') ? '×2' : '✓';
          } else if (badge) {
            badge.remove();
          }
        });

        const picked = this.charms.filter(Boolean).length;
        const label = this.querySelector('[data-bbc-picked="charms"]');
        if (label) label.textContent = picked + ' of 2 picked';
        this.props.charm1.value = this.charms[0] ? this.charms[0].name : '';
        this.props.charm2.value = this.charms[1] ? this.charms[1].name : '';
        if (picked === 2) this.hideError('charms');
        // наружу: quick-add не предлагает то, что уже стоит в слотах
        document.dispatchEvent(
          new CustomEvent('beadboo:charms', {
            detail: { picked: this.charms.filter(Boolean).map((c) => c.name) },
          })
        );
        if (this.solo) this.soloSync();
      }

      flashSlots() {
        const wrap = this.querySelector('.bbc-collar__strip');
        wrap.classList.remove('bbc-shake');
        void wrap.offsetWidth;
        wrap.classList.add('bbc-shake');
      }

      /* ── STEP 3 · font ──────────────────────────────── */
      initFont() {
        this.querySelectorAll('[data-bbc-font]').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.querySelectorAll('[data-bbc-font]').forEach((b) => {
              b.classList.remove('is-picked');
              b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('is-picked');
            btn.setAttribute('aria-checked', 'true');
            this.props.font.value = btn.dataset.bbcFont;
            const picked = this.querySelector('[data-bbc-picked="font"]');
            if (picked) picked.textContent = btn.dataset.bbcFont;
            /* «Let us pick» (2026-08-25, Илья): клик НЕ «применяет» шрифт —
               превью остаётся как было, меняется только состояние чипа.
               У делегирующего чипа нет data-bbc-fontstack — обходим превью. */
            if (btn.dataset.bbcFontstack) {
              const text = this.querySelector('.bbc-tag__text');
              if (text) text.style.fontFamily = btn.dataset.bbcFontstack;
              const mini = this.querySelector('[data-bbc-mininame]');
              if (mini) mini.style.fontFamily = btn.dataset.bbcFontstack;
              this.renderTag(); // ширина текста зависит от шрифта — пере-подгонка размера
              requestAnimationFrame(() => this.syncMiniShift()); // мини-тег: оптический центр под новый шрифт
            } else {
              // эффект-подтверждение выбора: короткий «поп» чипа
              btn.classList.remove('bbc-font--pop');
              void btn.offsetWidth;
              btn.classList.add('bbc-font--pop');
            }
            if (this.solo) this.soloSync(); // рекап финал-карточки + память дизайна
          });
        });
      }

      /* ── STEP 4 · name + back line + превью тега ────── */
      initText() {
        this.tagText = this.querySelector('.bbc-tag__text');
        this.side = 'front';

        this.querySelectorAll('[data-bbc-side]').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (btn.classList.contains('is-picked')) return;
            this.querySelectorAll('[data-bbc-side]').forEach((b) => {
              b.classList.remove('is-picked');
              b.setAttribute('aria-selected', 'false');
            });
            btn.classList.add('is-picked');
            btn.setAttribute('aria-selected', 'true');
            this.flipTag(btn.dataset.bbcSide);
          });
        });

        this.querySelectorAll('[data-bbc-backtype]').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.querySelectorAll('[data-bbc-backtype]').forEach((b) => {
              b.classList.remove('is-picked');
              b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('is-picked');
            btn.setAttribute('aria-checked', 'true');
            this.backType = btn.dataset.bbcBacktype;
            const input = this.querySelector('[data-bbc-input="back"]');
            if (this.backType === 'Phone') {
              input.maxLength = 12; // «858 905-4793» = 12 символов (10 цифр + пробел + дефис)
              input.placeholder = '858 905-4793';
              input.value = this.formatPhoneInput(input.value); // переформатировать уже введённое
            } else {
              input.maxLength = 12; // custom text — 12 символов (решение Ильи 2026-07-22)
              input.placeholder = 'Microchipped';
              input.value = input.value.slice(0, 12);
            }
            this.updateBackCount();
            this.syncBack();
            this.renderTag();
          });
        });

        // имя — как раньше; back-строка форматируется отдельной веткой
        const nameInput = this.querySelector('[data-bbc-input="name"]');
        nameInput.addEventListener('input', () => {
          const count = this.querySelector('[data-bbc-count="name"]');
          if (count) count.textContent = nameInput.value.length + '/' + nameInput.maxLength;
          // регистр свободный (решение Ильи 2026-07-21): гравируем как напечатано
          this.props.name.value = nameInput.value.trim();
          if (nameInput.value.trim()) this.hideError('name');
          if (this.solo) this.soloSync();
          this.renderTag();
        });

        const backInput = this.querySelector('[data-bbc-input="back"]');
        backInput.addEventListener('input', () => {
          // Phone: авто-формат прямо в поле по мере ввода (просьба Ильи 2026-07-22) —
          // отбрасываем всё кроме цифр, код страны/ведущую 1, режем до 10 цифр
          // и раскладываем как на теге: «858 905-4793». Каретку держим в конце.
          if (this.backType === 'Phone') {
            backInput.value = this.formatPhoneInput(backInput.value);
          }
          this.updateBackCount();
          this.syncBack();
          if (backInput.value.trim()) this.hideError('back');
          this.renderTag();
        });
      }

      /* счётчик back-поля: для телефона считаем ЦИФРЫ (макс 10), для текста —
         символы (макс 10) — так «10/10» отражает реальный лимит, а не длину
         отформатированной строки с пробелом и дефисом */
      updateBackCount() {
        const input = this.querySelector('[data-bbc-input="back"]');
        const count = this.querySelector('[data-bbc-count="back"]');
        if (!count) return;
        // Phone — считаем цифры (макс 10); Custom text — символы (макс 12)
        const n = this.backType === 'Phone' ? input.value.replace(/\D/g, '').length : input.value.length;
        count.textContent = n + (this.backType === 'Phone' ? '/10' : '/12');
      }

      /* ввод телефона → «858 905-4793» по мере набора. Цифры, без кода страны
         (ведущая 1) и лишнего, максимум 10 цифр. Прогрессивно: 858 → 858 905 →
         858 905-4793. splitPhone() для превью потом снова снимет \D — совместимо. */
      formatPhoneInput(raw) {
        let d = raw.replace(/\D/g, '');
        if (d.length === 11 && d[0] === '1') d = d.slice(1);
        d = d.slice(0, 10);
        if (d.length <= 3) return d;
        if (d.length <= 6) return d.slice(0, 3) + ' ' + d.slice(3);
        return d.slice(0, 3) + ' ' + d.slice(3, 6) + '-' + d.slice(6);
      }

      /* 3D-переворот тега при смене стороны: складываем ребром (90°),
         на ребре меняем текст, разворачиваем обратно с пружинкой */
      flipTag(side) {
        this.side = side;
        const stage = this.querySelector('[data-bbc-stage]');
        if (!stage) return this.renderTag();
        if (this.flipTimer) clearTimeout(this.flipTimer);
        stage.classList.remove('is-flip-in');
        stage.classList.add('is-flip-out');
        this.flipTimer = setTimeout(() => {
          this.syncTagFace(); // Polka Pup: зад без точек — сменить картинку в момент переворота
          this.renderTag();
          stage.classList.remove('is-flip-out');
          stage.classList.add('is-flip-in');
          this.flipTimer = setTimeout(() => {
            stage.classList.remove('is-flip-in');
            this.flipTimer = null;
          }, 340);
        }, 190);
      }

      syncBack() {
        const input = this.querySelector('[data-bbc-input="back"]');
        const v = input.value.trim(); // регистр свободный — как напечатано
        this.props.back.value = v ? this.backType + ': ' + v : '';
        if (this.solo) this.soloSync();
      }

      /* «858 905-4793» → ['858', '905-4793']. Работаем по цифрам, а не по тому,
         как человек расставил скобки/дефисы: 10 цифр (или 11 с ведущей 1) —
         код города отдельной строкой. Всё нестандартное отдаём одной строкой. */
      splitPhone(raw) {
        let d = raw.replace(/\D/g, '');
        if (d.length === 11 && d[0] === '1') d = d.slice(1);
        if (d.length !== 10) return null;
        return [d.slice(0, 3), d.slice(3, 6) + '-' + d.slice(6)];
      }

      renderTag() {
        if (!this.tagText) return;
        const name = this.querySelector('[data-bbc-input="name"]').value.trim();
        const back = this.querySelector('[data-bbc-input="back"]').value.trim();
        const shown = this.side === 'front' ? name || 'LUNA' : back || (this.backType === 'Phone' ? '858 905-4793' : 'Microchipped');
        /* телефон на реальном теге (фото Ильи 2026-07-22) набирается в ДВЕ строки:
           код города сверху и мельче (~0.7), остаток — крупной строкой под ним,
           обе по центру. Всё остальное (имя, custom text) — одной строкой. */
        const phone = this.side === 'back' && this.backType === 'Phone' ? this.splitPhone(shown) : null;
        this.tagText.classList.toggle('bbc-tag__text--two', !!phone);
        if (phone) {
          this.tagText.textContent = '';
          const area = document.createElement('span');
          area.className = 'bbc-tag__line bbc-tag__line--area';
          area.textContent = phone[0];
          const rest = document.createElement('span');
          rest.className = 'bbc-tag__line';
          rest.textContent = phone[1];
          this.tagText.append(area, rest);
        } else {
          this.tagText.textContent = shown;
        }
        /* размер как на реальных тегах: строка держится в ~62% ширины косточки.
           Ширину меряем через canvas (measureTextWidth), НЕ getBoundingClientRect:
           последний ломается при флипе (тег повёрнут rotateY(90°) → ширина ≈0 →
           фит не срабатывал, длинный текст вылезал за тег — баг Ильи 2026-07-22)
           и зависит от момента загрузки шрифта. Canvas иммунен к трансформам, а
           ширина линейна по font-size, поэтому ts считаем формулой без замера DOM. */
        const stage = this.stage || this.querySelector('[data-bbc-stage]');
        if (!stage) return;
        const frac = 0.62;
        const measure = phone ? phone[1] : shown; // у телефона меряем длинную строку
        // ширина при 100px + компенсация letter-spacing (0.02em = 2px/гэп при 100px)
        const w100 = this.measureTextWidth(this.tagText, measure) + Math.max(0, measure.length - 1) * 2;
        // rendered width = w100 * (ts*stageW/300) / 100; ≤ frac*stageW → stageW сокращается
        const ts = w100 > 0 ? Math.min(64, Math.max(16, (frac * 30000) / w100)) : 64;
        this.tagText.style.setProperty('--bbc-ts', ts);
        // оптическое центрирование по вертикали (см. verticalTrim): у bubble-шрифтов
        // метрики несимметричны и капс «оседает» ниже центра — компенсируем
        const px = (ts * stage.clientWidth) / 300;
        const k = phone ? 0 : this.verticalTrim(this.tagText, measure);
        this.tagText.style.setProperty('--bbc-vshift', (-k * px).toFixed(2) + 'px');
        // мини-тег шага 2 имя НЕ показывает (статичный «Name», решение Ильи):
        // длинные имена вылезают за рамки; шрифт ему меняет initFont
      }

      /* Ширина текста ТЕКУЩИМ шрифтом при 100px через canvas. Иммунна к CSS-
         трансформам (rotateY при флипе) и не требует, чтобы элемент был в потоке.
         Если шрифт ещё не догрузился — вернёт ширину фолбэка; loadingdone-ресинк
         в конструкторе перезапустит renderTag после фактической загрузки. */
      measureTextWidth(el, text) {
        try {
          const cs = getComputedStyle(el);
          const cvs = this._wcanvas || (this._wcanvas = document.createElement('canvas'));
          const ctx = cvs.getContext('2d');
          ctx.font = '400 100px ' + cs.fontFamily;
          return ctx.measureText(text || 'LUNA').width;
        } catch (e) {
          return 0;
        }
      }

      /* Оптический вертикальный центр строки для ТЕКУЩЕГО шрифта элемента.
         Геометрический центр line-box ≠ визуальный центр глифов: у bubble-шрифтов
         (Cherry Bomb One и т.п.) большой верхний запас метрик под диакритику, из-за
         чего капс визуально смещён вниз. Меряем реальные границы глифов через canvas
         и возвращаем сдвиг как ДОЛЮ font-size (>0 = глифы ниже центра, надо поднять).
         Доля от размера не зависит — считаем на 100px, применяем к фактическому. */
      verticalTrim(el, text) {
        try {
          const cs = getComputedStyle(el);
          const cvs = this._vcanvas || (this._vcanvas = document.createElement('canvas'));
          const ctx = cvs.getContext('2d');
          ctx.font = '400 100px ' + cs.fontFamily;
          ctx.textBaseline = 'alphabetic';
          const m = ctx.measureText(text || 'LUNA');
          const fa = m.fontBoundingBoxAscent;
          const fd = m.fontBoundingBoxDescent;
          const aa = m.actualBoundingBoxAscent;
          const ad = m.actualBoundingBoxDescent;
          if ([fa, fd, aa, ad].some((v) => typeof v !== 'number' || isNaN(v))) return 0;
          return (fa - fd - aa + ad) / 2 / 100;
        } catch (e) {
          return 0;
        }
      }

      /* мини-тег шага 2: тот же оптический сдвиг, но по своему (меньшему) размеру */
      syncMiniShift() {
        const mini = this.querySelector('[data-bbc-mininame]');
        if (!mini) return;
        const px = parseFloat(getComputedStyle(mini).fontSize) || 0;
        const k = this.verticalTrim(mini, mini.textContent || 'Name');
        mini.style.setProperty('--bbc-vshift', (-k * px).toFixed(2) + 'px');
      }

      /* ── валидация перед добавлением в корзину ────────
         Слушаем capture на document, а не на форме: обработчик Dawn
         (product-form.js) регистрируется на форме раньше нашего, и при
         listener'е на самой форме он успел бы отправить fetch до валидации.
         Capture на document гарантированно срабатывает первым; stopPropagation
         (не Immediate!) режет обработчики формы, но пропускает <beadboo-size>. */
      initValidation() {
        const form = document.getElementById(this.dataset.formId);
        if (!form) return;

        /* guard-модалка (паттерн dogIDs): чек-лист незаполненного вместо
           простыни ошибок. Размер тоже наш: читаем hidden-инпут <beadboo-size>,
           его собственный листенер лишь покажет inline-ошибку (defaultPrevented). */
        this.missingCopy = {
          size: 'Pick a size',
          charms: 'Fill both charm spots — or go “No charm”',
          name: "Add your pup's name",
          back: 'Add a phone number (or a short text) for the back',
        };
        this.modal = this.querySelector('[data-bbc-modal]');
        this.modalList = this.querySelector('[data-bbc-modal-list]');
        if (this.modal) {
          const closeBtn = this.querySelector('[data-bbc-modal-close]');
          if (closeBtn) closeBtn.addEventListener('click', () => this.modal.close());
          this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this.modal.close();
          });
          const go = this.querySelector('[data-bbc-modal-go]');
          if (go)
            go.addEventListener('click', () => {
              this.modal.close();
              if (this.firstMissing) this.jumpTo(this.firstMissing);
            });
        }

        document.addEventListener(
          'submit',
          (e) => {
            if (e.target !== form) return;
            // дизайн не собран → Add to cart не работает: ведём к конструктору.
            // stopImmediatePropagation: молчат и Dawn, и beadboo-size (его
            // inline-ошибка размера тут только шумела бы) — говорит визард.
            // solo-режим идёт мимо этой ветки: у него нет трека, к которому
            // скроллит wizSummon, — работает обычная guard-модалка ниже.
            if (!this.solo && this.classList.contains('bbc--wizard') && !this.wizFinished) {
              e.preventDefault();
              e.stopImmediatePropagation();
              this.wizSummon();
              return;
            }
            const missing = [];
            const sizeInput = document.querySelector('[data-bbs-input]');
            if (sizeInput && !sizeInput.value) missing.push('size');
            if (this.charms.filter(Boolean).length < 2) missing.push('charms');
            if (!this.props.name.value) missing.push('name');
            if (!this.props.back.value) missing.push('back');
            if (!missing.length) {
              this.persistClear(); // дизайн ушёл в корзину — память страницы больше не нужна
              return;
            }
            e.preventDefault();
            e.stopPropagation();
            missing.forEach((key) => this.showError(key)); // inline-метки остаются после закрытия
            this.firstMissing = missing[0];
            /* Не заполнен ровно один пункт (обычно размер) — модалка-чеклист из
               одной строки только добавляет клик: ведём прямо к месту и трясём
               его, чтобы было видно, чего не хватает (2026-08-27, Илья).
               Чеклист остаётся, когда пустых пунктов несколько. */
            if (missing.length === 1) {
              this.jumpTo(this.firstMissing);
              return;
            }
            if (this.modal && this.modalList && typeof this.modal.showModal === 'function') {
              this.modalList.innerHTML = '';
              missing.forEach((key) => {
                const li = document.createElement('li');
                li.className = 'bbcm__item';
                li.textContent = this.missingCopy[key] || key;
                this.modalList.appendChild(li);
              });
              this.modal.showModal();
            } else {
              this.jumpTo(this.firstMissing); // фолбэк без <dialog>: старое поведение
            }
          },
          true
        );
      }

      /* ── WIZARD (эксперимент в драфт-теме, 2026-08-13) ────────────────
         Шаги по одному за кнопкой Start designing. Прогрессивное улучшение:
         маркап по умолчанию — классический стек; здесь вешаем bbc--wizard,
         переносим variant-selects Dawn в панель шага 1 (остаётся потомком
         <product-info> — перерисовки Dawn работают штатно) и включаем хром. */
      initWizard() {
        this.wizHead = this.querySelector('[data-bbw-head]');
        this.wizNav = this.querySelector('[data-bbw-nav]');
        this.wizDone = this.querySelector('[data-bbw-done]');
        if (!this.wizHead || !this.wizNav || !this.wizDone) return;

        this.wizKeys = ['style', 'charms', 'text'];
        // перенос пикера Style внутрь панели шага 1; нет пикера (товар без
        // вариантов?) — шаг Style выпадает, визард живёт с тремя шагами
        const slot = this.querySelector('[data-bbw-style-slot]');
        const scope = this.closest('product-info') || document;
        const vs = scope.querySelector('variant-selects');
        if (slot && vs) {
          slot.appendChild(vs);
        } else {
          this.wizKeys = this.wizKeys.filter((k) => k !== 'style');
          const dot = this.querySelector('[data-bbw-dot="style"]');
          if (dot) dot.hidden = true;
          /* SOLO (2026-08-25): per-style товар — стиль зашит в карточку
             (data-bbc-solo-style из метаполя custom.bb_style). Вместо трека
             с Next/Back — 2 кнопки-аккордеона (Charms → Tag); дальше обычная
             wizard-инициализация не нужна. */
          if (this.dataset.bbcSoloStyle) {
            this.applyStyle(this.dataset.bbcSoloStyle);
            this.initSolo();
            return;
          }
        }
        const total = this.querySelector('[data-bbw-total]');
        if (total) total.textContent = this.wizKeys.length;

        // лейблы кнопки Next: подсказываем, что дальше; на последнем — Finish
        this.wizNextLabels = {
          style: 'Next · Charms',
          charms: 'Next · Tag',
          text: 'Finish my design ✨',
        };

        this.wizStep = 0; // индекс в wizKeys
        this.wizMax = 0; // самый дальний посещённый шаг (бусины кликабельны до него)
        this.wizStarted = true; // v3: без гейта — шаг 1 (Style) виден сразу
        this.wizFinished = false;
        this.classList.add('bbc--wizard');

        this.querySelector('[data-bbw-back]').addEventListener('click', () => {
          if (this.wizStep > 0) this.wizShow(this.wizStep - 1);
        });
        this.querySelector('[data-bbw-next]').addEventListener('click', () => this.wizNext());
        this.querySelectorAll('[data-bbw-dot]').forEach((dot) => {
          dot.addEventListener('click', () => {
            const i = this.wizKeys.indexOf(dot.dataset.bbwDot);
            if (i !== -1 && i <= this.wizMax && i !== this.wizStep) this.wizShow(i);
          });
        });
        this.querySelector('[data-bbw-edit]').addEventListener('click', () => this.wizReopen(0));
        this.querySelectorAll('[data-bbw-recap-go]').forEach((row) => {
          row.addEventListener('click', () => {
            const i = this.wizKeys.indexOf(row.dataset.bbwRecapGo);
            this.wizReopen(i === -1 ? 0 : i);
          });
        });

        // Add to cart заперт, пока дизайн не собран (решение Ильи 2026-08-13):
        // кнопка приглушена + видимая подпись; клик перехватывает
        // submit-валидация и зовёт wizSummon
        this.wizLockAtc(true);

        // автостарт: хром показываем сразу, без кнопки Start
        this.wizHead.hidden = false;
        this.wizNav.hidden = false;
        this.wizShow(0);
      }

      /* ── SOLO-режим (2026-08-25): per-style товар ─────────────────
         Стиль = сама карточка товара, шагов два: Charms → Tag. Навигация —
         две кнопки-аккордеона; вторая заперта, пока не выбраны оба чарма.
         Add to cart разлочивается сам, как только весь дизайн валиден
         (кнопки Finish нет) — submit-валидация с guard-модалкой остаётся. */
      initSolo() {
        this.solo = true;
        this.classList.add('bbc--wizard', 'bbc--solo');
        this.wizFinished = false;
        // память дизайна: глушим сохранение, пока не отработает soloRestore —
        // иначе первый же soloSync ниже затирает сохранённое пустым состоянием
        // (инцидент при первом прогоне 2026-08-25)
        this.persistMuted = true;
        // 2026-08-25, UX-решение Ильи+ревью: замок с шага 2 снят — шаги
        // независимы по данным, полноту сторожат запертый ATC и guard-модалка
        this.soloAutoDone = false; // автопереход к шагу 2 делаем один раз
        this.soloOpenKey = null;
        this.soloBtns = {
          charms: this.querySelector('[data-bbw-solobtn="charms"]'),
          text: this.querySelector('[data-bbw-solobtn="text"]'),
        };
        this.soloPanels = {
          charms: this.querySelector('[data-bbw-panel="charms"]'),
          text: this.querySelector('[data-bbw-panel="text"]'),
        };
        Object.keys(this.soloBtns).forEach((key) => {
          const btn = this.soloBtns[key];
          if (!btn) return;
          btn.hidden = false;
          btn.addEventListener('click', () => {
            this.soloOpen(this.soloOpenKey === key ? null : key);
          });
        });
        this.wizLockAtc(true);
        this.soloSync();
        // по дефолту обе панели свёрнуты (2026-08-25, Илья) — человек сам
        // жмёт кнопку 1; автораскрытие остаётся только на переходе к шагу 2
        this.soloOpen(null);

        // финал-карточка: Edit design и строки рекапа ведут в свою панель
        // (wizReopen из wizard-режима в solo не существует — свои листенеры)
        const editBtn = this.querySelector('[data-bbw-edit]');
        if (editBtn) editBtn.addEventListener('click', () => this.soloEdit('charms'));
        this.querySelectorAll('[data-bbw-recap-go]').forEach((row) => {
          row.addEventListener('click', () => {
            const key = row.dataset.bbwRecapGo;
            if (key === 'style') return; // стиль зашит в карточку товара
            this.soloEdit(key === 'charms' ? 'charms' : 'text');
          });
        });
        // любой клик внутри конструктора откладывает финал-карточку («тишина»
        // должна быть настоящей), blur инпута — перезапускает отсчёт
        this.addEventListener(
          'click',
          () => {
            if (this.wizFinished && !this.soloCardShown) this.soloCardArm();
          },
          true
        );
        this.addEventListener('focusout', () => this.soloCardArm());

        // вернувшийся человек застаёт дизайн как оставил (localStorage)
        this.soloRestore();
      }

      /* открыть панель key (null — свернуть всё); открыта максимум одна.
         Панели складываются/раскрываются плавной анимацией высоты (2026-08-25):
         мгновенный скачок «выбрал чарм — всё перестроилось» дезориентировал. */
      soloOpen(key) {
        if (this.soloOpenKey === key) return;
        this.soloOpenKey = key;
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        ['charms', 'text'].forEach((k) => {
          const p = this.soloPanels[k];
          const b = this.soloBtns[k];
          const open = k === key;
          if (b) {
            b.classList.toggle('is-open', open);
            b.setAttribute('aria-expanded', open ? 'true' : 'false');
          }
          if (!p) return;
          const isOpen = p.classList.contains('is-current');
          if (open === isOpen) return;
          if (reduce) {
            p.classList.toggle('is-current', open);
            return;
          }
          if (open) this.soloExpand(p);
          else this.soloCollapse(p);
        });
        // превью в скрытой панели мерились при ширине 0 — пере-фит после показа
        if (key) {
          requestAnimationFrame(() => {
            this.renderTag();
            this.syncMiniShift();
          });
        }
      }

      /* конец height-анимации панели: transitionend с таймером-страховкой;
         поколение (_bbGen) защищает от гонки при быстрых повторных кликах */
      soloAnimEnd(p, cb) {
        const gen = (p._bbGen = (p._bbGen || 0) + 1);
        const done = (e) => {
          if (e && (e.target !== p || e.propertyName !== 'height')) return;
          p.removeEventListener('transitionend', done);
          clearTimeout(t);
          if (p._bbGen !== gen) return;
          cb();
        };
        const t = setTimeout(done, 550);
        p.addEventListener('transitionend', done);
      }

      soloExpand(p) {
        p.classList.add('is-current', 'is-anim');
        p.style.height = '0px';
        p.style.opacity = '0';
        void p.offsetHeight;
        p.style.height = p.scrollHeight + 'px';
        p.style.opacity = '1';
        this.soloAnimEnd(p, () => {
          p.classList.remove('is-anim');
          p.style.height = '';
          p.style.opacity = '';
        });
      }

      soloCollapse(p) {
        p.classList.add('is-anim');
        p.style.height = p.scrollHeight + 'px';
        p.style.opacity = '1';
        void p.offsetHeight;
        p.style.height = '0px';
        p.style.opacity = '0';
        this.soloAnimEnd(p, () => {
          p.classList.remove('is-current', 'is-anim');
          p.style.height = '';
          p.style.opacity = '';
        });
      }

      /* единая точка истины solo-состояния: подписи кнопок, done/lock,
         автопереход к шагу 2 и лок Add to cart. Зовётся из renderCharms,
         syncBack и инпута имени. */
      soloSync() {
        if (!this.solo) return;
        const picked = this.charms.filter(Boolean);
        const charmsDone = picked.length === 2;
        const nameVal = this.props.name.value;
        const backVal = this.props.back.value;
        const textDone = Boolean(nameVal && backVal);

        const bCharms = this.soloBtns.charms;
        if (bCharms) {
          bCharms.classList.toggle('is-done', charmsDone);
          const val = bCharms.querySelector('[data-bbw-soloval="charms"]');
          if (val) {
            let label = 'Both included free';
            if (picked.length === 1) label = picked[0].name + ' · pick 1 more';
            else if (charmsDone)
              label =
                picked[0].name === 'Let us pick'
                  ? 'We’ll pick for you ✨'
                  : picked[0].name === picked[1].name
                    ? picked[0].name + ' ×2'
                    : picked[0].name + ' + ' + picked[1].name;
            val.textContent = label;
          }
        }

        /* Первый собранный комплект: НЕ дёргаем экран мгновенно (2026-08-25,
           Илья: «не успевает посмотреть, что выбрал»). Держим шаг 1 открытым
           ~1.4 c — человек видит оба чарма в слотах и пульс-подтверждение —
           и только потом плавно переходим к шагу 2. Если за паузу он передумал
           (снял чарм, сам переключил панель) — переход отменяется. */
        if (charmsDone && !this.soloAutoDone && this.soloOpenKey === 'charms') {
          this.soloAutoDone = 'pending';
          clearTimeout(this.soloAdvT);
          const strip = this.querySelector('.bbc-collar__strip');
          if (strip) {
            strip.classList.remove('is-complete');
            void strip.offsetWidth;
            strip.classList.add('is-complete');
          }
          this.soloAdvT = setTimeout(() => {
            if (this.charms.filter(Boolean).length === 2 && this.soloOpenKey === 'charms') {
              this.soloAutoDone = true;
              this.soloOpen('text');
            } else {
              this.soloAutoDone = false;
            }
          }, 1400);
        }
        if (!charmsDone && this.soloAutoDone === 'pending') {
          clearTimeout(this.soloAdvT);
          this.soloAutoDone = false;
        }

        const bText = this.soloBtns.text;
        if (bText) {
          bText.classList.toggle('is-done', textDone);
          const val = bText.querySelector('[data-bbw-soloval="text"]');
          if (val) {
            if (nameVal || backVal) {
              const parts = [];
              if (nameVal) parts.push(nameVal);
              if (backVal) parts.push(backVal.replace(/^(Phone|Custom text): /, ''));
              val.textContent = parts.join(' · ');
            } else {
              val.textContent = 'Name, font & your number';
            }
          }
        }

        const finished = charmsDone && textDone;
        if (finished !== this.wizFinished) {
          this.wizFinished = finished;
          this.wizLockAtc(!finished);
        }
        this.soloCardArm();
        this.persistSave();
      }

      /* ── финал-карточка solo (2026-08-25, Илья: «когда оба пункта заполнены,
         должно выскакивать») ────────────────────────────────────────────
         Появляется после ПАУЗЫ взаимодействия, не мгновенно: finished=true
         наступает с первой цифры телефона, и дёргать экран под печатающим
         нельзя. Safari не фокусит кнопки по клику, поэтому «тишина N мс»
         надёжнее activeElement; для текстовых инпутов фокус всё же ждём —
         focusout перезапустит таймер. Рисунок пауз повторяет автопереход
         charms→tag (1.4 c): открыта панель → 2.8 c, всё свёрнуто → 1.2 c. */
      soloCardArm() {
        if (!this.solo) return;
        clearTimeout(this.soloCardT);
        if (!this.wizFinished) return this.soloCardShow(false);
        if (this.soloCardShown) return this.soloCardShow(true); // уже видна — обновить рекап
        const wait = this.soloOpenKey ? 2800 : 1200;
        this.soloCardT = setTimeout(() => {
          if (!this.wizFinished || this.soloCardShown) return;
          const ae = document.activeElement;
          if (ae && this.contains(ae) && ae.matches('input')) return; // ещё печатает
          this.soloCardShow(true);
        }, wait);
      }

      soloCardShow(show) {
        if (show === !!this.soloCardShown) {
          if (show) {
            this.wizRecap();
            this.doneTitleSync();
          }
          return;
        }
        this.soloCardShown = show;
        clearTimeout(this.soloCardT);
        const btns = [this.soloBtns.charms, this.soloBtns.text];
        if (show) {
          this.wizRecap();
          this.doneTitleSync();
          const styleRow = this.querySelector('[data-bbw-recap-go="style"]');
          if (styleRow) styleRow.disabled = true; // solo: стиль зашит в карточку товара
          this.soloOpen(null);
          btns.forEach((b) => b && (b.hidden = true));
          this.wizDone.hidden = false;
          requestAnimationFrame(() => this.wizDone.scrollIntoView({ behavior: 'smooth', block: 'nearest' }));
        } else {
          this.wizDone.hidden = true;
          btns.forEach((b) => b && (b.hidden = false));
        }
      }

      /* клик по Edit design / строке рекапа: карточка прячется, открывается
         нужная панель — кнопки-шаги возвращаются на место */
      soloEdit(key) {
        this.soloCardShow(false);
        this.soloOpen(key);
        // карточка не возвращается сама, пока человек не начал взаимодействовать:
        // click-capture успел взвести таймер ДО этого хендлера — гасим
        clearTimeout(this.soloCardT);
        const b = this.soloBtns[key];
        if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      /* заголовок финал-карточки: эффект авторства (Franke, Schreier & Kaiser
         2010 — WTP растёт через чувство достижения и видимый вклад). Имя —
         как напечатано (правило бренда), фолбэк — прежний нейтральный. */
      doneTitleSync() {
        const t = this.querySelector('[data-bbw-done-title]');
        if (!t) return;
        const name = this.props.name.value;
        t.textContent = name ? name + '’s collar — designed by you ✨' : 'Your design is ready ✨';
      }

      /* ── память дизайна (localStorage, 2026-08-25) ─────────────────────
         IKEA-эффект исчезает у брошенной на середине сборки (Norton et al.
         2012) — вернувшийся человек должен застать всё как оставил.
         Ключ — путь товара; TTL 14 дней; очистка — после Add to cart. */
      persistKey() {
        return 'bbc:' + location.pathname;
      }

      persistSave() {
        if (!this.solo || this.persistMuted) return;
        try {
          const nameEl = this.querySelector('[data-bbc-input="name"]');
          const backEl = this.querySelector('[data-bbc-input="back"]');
          localStorage.setItem(
            this.persistKey(),
            JSON.stringify({
              c: this.charms.map((x) => (x ? x.name : null)),
              f: this.props.font.value,
              n: nameEl ? nameEl.value : '',
              bt: this.backType,
              b: backEl ? backEl.value : '',
              t: Date.now(),
            })
          );
        } catch (e) {
          /* private mode и т.п. — молча живём без памяти */
        }
      }

      persistClear() {
        try {
          localStorage.removeItem(this.persistKey());
        } catch (e) {}
      }

      /* восстановление — через клики/инпуты по реальным контролам, чтобы
         переиспользовать все side-эффекты (превью, счётчики, формат телефона) */
      soloRestore() {
        let d = null;
        try {
          d = JSON.parse(localStorage.getItem(this.persistKey()) || 'null');
        } catch (e) {}
        if (!d || !d.t || Date.now() - d.t > 14 * 864e5) {
          this.persistMuted = false; // нечего восстанавливать — сохранение снова живёт
          return;
        }
        try {
          const chips = Array.from(this.querySelectorAll('[data-bbc-charm]'));
          const names = Array.isArray(d.c) ? d.c : [];
          if (names[0] === 'Let us pick' && names[1] === 'Let us pick') {
            const magic = this.querySelector('[data-bbc-fillboth]');
            if (magic) magic.click();
          } else {
            names.forEach((n) => {
              if (!n) return;
              const chip = chips.find((c) => c.dataset.bbcCharm === n && !c.hasAttribute('data-bbc-fillboth'));
              if (chip) chip.click();
            });
          }
          // выбранные чармы не должны сразу автоперекидывать на шаг 2
          if (this.charms.filter(Boolean).length === 2) this.soloAutoDone = true;
          if (d.f && d.f !== this.props.font.value) {
            const fbtn = Array.from(this.querySelectorAll('[data-bbc-font]')).find((b) => b.dataset.bbcFont === d.f);
            if (fbtn) fbtn.click();
          }
          if (d.bt === 'Custom text') {
            const bt = this.querySelector('[data-bbc-backtype="Custom text"]');
            if (bt) bt.click();
          }
          const nameEl = this.querySelector('[data-bbc-input="name"]');
          if (nameEl && d.n) {
            nameEl.value = d.n;
            nameEl.dispatchEvent(new Event('input', { bubbles: true }));
          }
          const backEl = this.querySelector('[data-bbc-input="back"]');
          if (backEl && d.b) {
            backEl.value = d.b;
            backEl.dispatchEvent(new Event('input', { bubbles: true }));
          }
        } finally {
          this.persistMuted = false;
        }
        this.persistSave(); // нормализованное состояние (формат телефона и т.п.)
        this.soloSync();
      }

      /* визуальный лок кнопки Add to cart (сам перехват — в initValidation):
         приглушение + видимая подпись-объяснение под кнопкой (title на мобилке
         не существует, серая кнопка без слов читается как «сломано») */
      wizLockAtc(lock) {
        const form = document.getElementById(this.dataset.formId);
        const btn =
          (form && form.querySelector('[type="submit"]')) ||
          document.querySelector('[type="submit"][form="' + this.dataset.formId + '"]');
        if (!btn) return;
        btn.classList.toggle('is-bbw-locked', lock);
        if (lock) btn.setAttribute('title', 'Finish your design first 🐾');
        else btn.removeAttribute('title');
        if (!this.wizAtcNote) {
          this.wizAtcNote = document.createElement('p');
          this.wizAtcNote.className = 'bbw-atc-note';
          this.wizAtcNote.textContent = 'Design your collar first 🐾';
          btn.insertAdjacentElement('afterend', this.wizAtcNote);
        }
        this.wizAtcNote.hidden = !lock;
      }

      /* клик по запертому Add to cart: ведём человека к текущему шагу */
      wizSummon() {
        this.wizHead.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const shakee = this.querySelector('[data-bbw-panel].is-current') || this.wizHead;
        shakee.classList.remove('bbc-shake');
        void shakee.offsetWidth;
        shakee.classList.add('bbc-shake');
      }

      /* открыть визард на шаге i (после финиша — через wizReopen) */
      wizOpen(i) {
        this.wizStarted = true;
        this.wizDone.hidden = true;
        this.wizHead.hidden = false;
        this.wizNav.hidden = false;
        this.wizShow(i);
      }

      /* вернуться из карточки-резюме на шаг i; пока редактирует — корзина
         снова заперта до нового Finish */
      wizReopen(i) {
        this.wizFinished = false;
        this.wizLockAtc(true);
        this.wizOpen(i);
      }

      wizShow(i) {
        this.wizStep = i;
        this.wizMax = Math.max(this.wizMax, i);
        const key = this.wizKeys[i];

        this.querySelectorAll('[data-bbw-panel]').forEach((p) => {
          p.classList.toggle('is-current', p.dataset.bbwPanel === key);
        });
        this.querySelectorAll('[data-bbw-dot]').forEach((dot) => {
          const di = this.wizKeys.indexOf(dot.dataset.bbwDot);
          dot.classList.toggle('is-current', di === i);
          dot.classList.toggle('is-done', di < i || this.wizFinished);
          dot.classList.toggle('is-open', di <= this.wizMax);
          if (di === i) dot.setAttribute('aria-current', 'step');
          else dot.removeAttribute('aria-current');
        });
        const fill = this.querySelector('[data-bbw-fill]');
        const n = this.wizKeys.length;
        // endowed progress: заливка никогда не с нуля — Style уже выбран
        // дефолтом, стартовый «задел» ~14% удваивает мотивацию дойти до конца
        // (Nunes & Drèze 2006; см. /research/wizard-vs-inline-conversion.md)
        if (fill) fill.style.width = Math.max(14, n > 1 ? (i / (n - 1)) * 100 : 100) + '%';
        const num = this.querySelector('[data-bbw-stepnum]');
        if (num) num.textContent = i + 1;
        const next = this.querySelector('[data-bbw-next]');
        if (next) next.innerHTML = this.wizNextLabels[key] || 'Next';
        const back = this.querySelector('[data-bbw-back]');
        if (back) back.hidden = i === 0;

        /* превью в скрытых панелях мерились при clientWidth=0 — пере-фит
           после того, как панель реально показана */
        requestAnimationFrame(() => {
          this.renderTag();
          this.syncMiniShift();
        });
        // держим шапку визарда в поле зрения (панели разной высоты)
        if (this.wizHeadShown) this.wizHead.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        this.wizHeadShown = true;
        const panel = this.querySelector('[data-bbw-panel="' + key + '"]');
        if (panel) panel.focus({ preventScroll: true });
      }

      /* Next: лёгкий гейт текущего шага (та же валидация, что у Add to cart),
         на последнем шаге — финиш с рекапом */
      wizNext() {
        const key = this.wizKeys[this.wizStep];
        if (key === 'charms' && this.charms.filter(Boolean).length < 2) {
          this.showError('charms');
          this.flashSlots();
          return;
        }
        if (key === 'text') {
          const missing = [];
          if (!this.props.name.value) missing.push('name');
          if (!this.props.back.value) missing.push('back');
          if (missing.length) {
            missing.forEach((k) => this.showError(k));
            this.jumpTo(missing[0]);
            return;
          }
          return this.wizFinish();
        }
        this.wizShow(this.wizStep + 1);
      }

      wizFinish() {
        this.wizFinished = true;
        this.wizLockAtc(false);
        this.wizMax = this.wizKeys.length - 1;
        this.wizHead.hidden = true;
        this.wizNav.hidden = true;
        this.querySelectorAll('[data-bbw-panel]').forEach((p) => p.classList.remove('is-current'));
        this.wizRecap();
        this.doneTitleSync(); // «Luna’s collar — designed by you ✨» и в wizard-режиме
        this.wizDone.hidden = false;
        // следующий обязательный выбор — размер: подводим к нему
        const size = document.querySelector('beadboo-size');
        if (size) size.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      wizRecap() {
        const set = (key, val) => {
          const el = this.querySelector('[data-bbw-recap="' + key + '"]');
          if (el) el.textContent = val || '—';
        };
        set('style', this.currentStyle);
        const c1 = this.charms[0] && this.charms[0].name;
        const c2 = this.charms[1] && this.charms[1].name;
        let charms = '';
        if (c1 && c2)
          charms = c1 === 'Let us pick' && c2 === 'Let us pick' ? 'We’ll pick for you ✨' : c1 === c2 ? c1 + ' ×2' : c1 + ' + ' + c2;
        set('charms', charms);
        set('font', this.props.font.value === 'Let us pick' ? 'We’ll pick for you ✨' : this.props.font.value);
        set('name', this.props.name.value);
        set('back', this.props.back.value);
      }

      /* скролл + встряска нужного места; для текстовых полей — ещё и фокус.
         В wizard-режиме сперва открываем нужный шаг (панель может быть скрыта). */
      jumpTo(key) {
        // wizard: раскрыть шаг, где живёт незаполненное (size — вне визарда)
        if (this.solo && key !== 'size') {
          // solo: просто открыть панель, где живёт незаполненное
          const panelKey = key === 'charms' ? 'charms' : 'text';
          if (this.soloOpenKey !== panelKey) this.soloOpen(panelKey);
        } else if (this.classList.contains('bbc--wizard') && key !== 'size') {
          const panelKey = key === 'charms' ? 'charms' : 'text';
          const i = this.wizKeys.indexOf(panelKey);
          if (i !== -1) {
            const panel = this.querySelector('[data-bbw-panel="' + panelKey + '"]');
            const shown = this.wizStarted && !this.wizFinished && panel && panel.classList.contains('is-current');
            if (!shown) {
              if (this.wizFinished) this.wizReopen(i);
              else this.wizOpen(i);
            }
          }
        }
        let focus = null;
        let el = null;
        if (key === 'size') {
          el = document.querySelector('beadboo-size');
        } else if (key === 'charms') {
          el = this.querySelector('[data-bbc-step="charms"]');
        } else {
          focus = this.querySelector('[data-bbc-input="' + key + '"]');
          el = focus ? focus.closest('.bbc-field') : null;
        }
        if (!el) return;
        const shake = () => {
          el.classList.remove('bbc-shake');
          void el.offsetWidth;
          el.classList.add('bbc-shake');
          if (focus) focus.focus({ preventScroll: true });
        };
        /* Тряска должна начаться, когда элемент УЖЕ на экране: иначе она
           проигрывается за кадром, пока идёт smooth-скролл, и пользователь
           её не видит (2026-08-27). Ждём scrollend, страхуемся таймером. */
        const box = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const alreadyVisible = box.top >= 0 && box.bottom <= vh;
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (alreadyVisible) {
          shake();
          return;
        }
        let fired = false;
        const once = () => {
          if (fired) return;
          fired = true;
          document.removeEventListener('scrollend', once);
          shake();
        };
        if ('onscrollend' in window) document.addEventListener('scrollend', once);
        setTimeout(once, 650); // фолбэк: Safari без scrollend + прерванный скролл
      }

      showError(key) {
        const el = this.querySelector('[data-bbc-error="' + key + '"]');
        if (el) el.hidden = false;
      }

      hideError(key) {
        const el = this.querySelector('[data-bbc-error="' + key + '"]');
        if (el) el.hidden = true;
      }
    }
  );
}

/* beadboo — обязательный выбор размера (snippets/beadboo-size.liquid).
   Отдельный от 4 шагов блок над Quantity; без выбора submit блокируется,
   блок трясётся. Регистрируется ПОСЛЕ beadboo-customizer: его capture-листенер
   на document срабатывает вторым, видит e.defaultPrevented от кастомайзера
   и тогда не перетягивает скролл на себя. */
if (!customElements.get('beadboo-size')) {
  customElements.define(
    'beadboo-size',
    class BeadbooSize extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('[data-bbs-input]');
        this.hintOut = this.querySelector('[data-bbs-hint-out]');
        this.pickedOut = this.querySelector('[data-bbs-picked]');
        this.error = this.querySelector('[data-bbs-error]');

        /* Размер выбирается селектом (карточки с силуэтами убраны 2026-07-18). */
        this.select = this.querySelector('[data-bbs-select]');
        if (this.select) {
          this.select.addEventListener('change', () => this.pickFromSelect());
          this.pickFromSelect(); // восстановить состояние после back/forward
        }

        /* Size guide — нативный <dialog>: backdrop, Esc и возврат фокуса из коробки.
           showModal() есть во всех целевых браузерах; если вдруг нет — открываем как
           обычный блок, чтобы гайд остался доступен. */
        this.guide = this.querySelector('[data-bbs-guide]');
        const openBtn = this.querySelector('[data-bbs-guide-open]');
        const closeBtn = this.querySelector('[data-bbs-guide-close]');
        if (this.guide && openBtn) {
          openBtn.addEventListener('click', () => {
            if (typeof this.guide.showModal === 'function') this.guide.showModal();
            else this.guide.setAttribute('open', '');
          });
          if (closeBtn) closeBtn.addEventListener('click', () => this.guide.close());
          // клик по подложке вне карточки — тоже закрывает
          this.guide.addEventListener('click', (e) => {
            if (e.target === this.guide) this.guide.close();
          });
        }

        this.initPreview();

        const form = document.getElementById(this.dataset.formId);
        if (!form) return;
        document.addEventListener(
          'submit',
          (e) => {
            if (e.target !== form) return;
            if (this.input && this.input.value) return;
            const otherScrolls = e.defaultPrevented; // кастомайзер уже скроллит к себе
            e.preventDefault();
            e.stopPropagation();
            if (this.error) this.error.hidden = false;
            this.classList.remove('bbc-shake');
            void this.offsetWidth;
            this.classList.add('bbc-shake');
            if (!otherScrolls) this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          },
          true
        );
      }

      pickFromSelect() {
        const value = this.select.value;
        const opt = this.select.selectedOptions[0];
        if (this.input) this.input.value = value;
        if (this.pickedOut) this.pickedOut.textContent = value || "Who's it for?";
        // хинт живёт только у ВЫБРАННОГО размера (2026-08-25): дефолтная
        // простыня дублировала Size guide и убрана
        if (this.hintOut) {
          if (value && opt && opt.dataset.hint) {
            this.hintOut.innerHTML = opt.dataset.hint;
            this.hintOut.hidden = false;
          } else {
            this.hintOut.hidden = true;
          }
        }
        this.classList.toggle('is-picked', Boolean(value));
        if (this.error && value) this.error.hidden = true;
        this.updatePreview();
      }

      /* ── превью выбранного размера (эксперимент 2026-08-04) ──
         Фото style×size живут ассетами темы (НЕ в медиа товара — в галерее
         их быть не должно). Кнопка появляется только когда выбран размер И
         у текущего Style есть фото в data-bbs-photomap; клик — модалка.
         Style отслеживаем тем же троеточием, что и превью тега в кастомайзере:
         change на document + pub/sub variantChange Dawn + начальное состояние. */
      initPreview() {
        this.previewBtn = this.querySelector('[data-bbs-preview-open]');
        this.previewDlg = this.querySelector('[data-bbs-preview]');
        if (!this.previewBtn || !this.previewDlg) return;
        try {
          this.photoMap = JSON.parse(this.previewBtn.dataset.bbsPhotomap || '{}');
        } catch (e) {
          this.photoMap = {};
        }
        this.previewImg = this.previewDlg.querySelector('[data-bbs-preview-img]');
        this.previewThumb = this.previewBtn.querySelector('[data-bbs-preview-thumb]');
        this.previewNote = this.previewDlg.querySelector('[data-bbs-preview-note]');
        this.previewStyleOut = this.previewDlg.querySelector('[data-bbs-preview-style]');
        this.previewLetterOut = this.previewDlg.querySelector('[data-bbs-preview-letter]');
        this.previewLetterBtn = this.previewBtn.querySelector('[data-bbs-preview-letter-btn]');

        this.previewBtn.addEventListener('click', () => {
          if (!this.previewUrl) return;
          if (this.previewImg && this.previewImg.getAttribute('src') !== this.previewUrl) {
            this.previewImg.src = this.previewUrl;
          }
          if (typeof this.previewDlg.showModal === 'function') this.previewDlg.showModal();
          else this.previewDlg.setAttribute('open', '');
        });
        const closeBtn = this.previewDlg.querySelector('[data-bbs-preview-close]');
        if (closeBtn) closeBtn.addEventListener('click', () => this.previewDlg.close());
        this.previewDlg.addEventListener('click', (e) => {
          if (e.target === this.previewDlg) this.previewDlg.close();
        });

        const isStyleInput = (el) =>
          el &&
          ((el.matches('input[type="radio"]') && /^Style(-\d+)?$/.test(el.name)) ||
            (el.matches('select') && /options\[Style\]/.test(el.name || '')));
        document.addEventListener('change', (e) => {
          if (isStyleInput(e.target)) {
            this.currentStyle = e.target.value;
            this.updatePreview();
          }
        });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const opts = (event && event.data && event.data.variant && event.data.variant.options) || [];
            const hit = opts.find((v) => this.photoMap[v]);
            this.currentStyle = hit || opts[0] || '';
            this.updatePreview();
          });
        }
        const checked = document.querySelector('input[type="radio"][name^="Style-"]:checked');
        const dropdown = document.querySelector('select[name="options[Style]"]');
        this.currentStyle = checked ? checked.value : dropdown ? dropdown.value : '';
        this.updatePreview();
      }

      updatePreview() {
        if (!this.previewBtn) return;
        // из value селекта («M · neck 14–19 in (36–48 cm)») берём букву размера
        const value = this.select ? this.select.value : '';
        const letter = value ? value.split(' ')[0] : '';
        const styleMap = (this.photoMap && this.photoMap[this.currentStyle]) || null;
        const url = styleMap && letter ? styleMap[letter] : '';
        this.previewUrl = url || '';
        if (!url) {
          this.previewBtn.hidden = true;
          if (this.previewDlg && this.previewDlg.open) this.previewDlg.close();
          return;
        }
        this.previewBtn.hidden = false;
        if (this.previewLetterBtn) this.previewLetterBtn.textContent = letter;
        if (this.previewThumb && this.previewThumb.getAttribute('src') !== url) this.previewThumb.src = url;
        if (this.previewStyleOut) this.previewStyleOut.textContent = this.currentStyle;
        if (this.previewLetterOut) this.previewLetterOut.textContent = letter;
        if (this.previewNote) this.previewNote.textContent = value;
        if (this.previewImg) {
          this.previewImg.alt = this.currentStyle + ' collar, size ' + letter;
          // модалка уже открыта (клиент щёлкает размеры) — обновить фото на лету
          if (this.previewDlg && this.previewDlg.open && this.previewImg.getAttribute('src') !== url) {
            this.previewImg.src = url;
          }
        }
      }
    }
  );
}

/* Первый клик по стилю, который Shopify считает выбранным с загрузки (Picnic Crush).
   Галерея теперь открывается на обложке коллекции, а не на фото этого стиля, но радио
   уже checked — браузер не шлёт change, Dawn ничего не перерисовывает, и клик выглядит
   мёртвым (работает только через «выбрать другой стиль → вернуться»).
   Снимаем состояние checked на pointerdown (до того, как браузер его изменит) и, если
   инпут уже был выбран, шлём change сами: он всплывает до <variant-selects> и запускает
   штатный путь Dawn (fetch ?variant= → updateMedia). */
(function bbStyleReclick() {
  const isStyleInput = (el) =>
    !!el && el.matches('input[type="radio"]') && /^Style(-\d+)?$/.test(el.name || '');

  const inputFor = (target) => {
    if (!target || typeof target.closest !== 'function') return null;
    const el = target.closest('input[type="radio"], label[for]');
    if (!el) return null;
    if (el.matches('input')) return el;
    const input = document.getElementById(el.htmlFor);
    return input && input.matches('input[type="radio"]') ? input : null;
  };

  /* инпут, который на момент нажатия уже был выбран → его click не даст change */
  let armed = null;

  document.addEventListener(
    'pointerdown',
    (e) => {
      const input = inputFor(e.target);
      armed = isStyleInput(input) && input.checked ? input : null;
    },
    true
  );

  /* клик по <label> порождает второй click уже на самом инпуте — armed гасим сразу,
     чтобы change ушёл ровно один раз */
  document.addEventListener('click', (e) => {
    const input = inputFor(e.target);
    if (!input || input !== armed) {
      armed = null;
      return;
    }
    armed = null;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
